import { isTenantRootDomain } from "@/lib/tenant";

export const APP_HOME_ROUTE = "/ai-agents/insights";
export const ROOT_WORKSPACE_ROUTE = "/workspace";

export const getPostAuthRoute = (hostname: string) =>
  isTenantRootDomain(hostname) ? ROOT_WORKSPACE_ROUTE : APP_HOME_ROUTE;
